import { apiClient } from "helpers/api_helper";

export const getAllStoreLedgerData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/StoreLedger/GetStoreLedger`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
// export const getAllStoreReciept = async (data: any) => {
//     try {
//         const response = await apiClient.get(`/api/v1/StoreLedger/GetInerStoreMayaveInvoice?invoiceNo=${data}`);
//         console.log(response)
//         return response;
//     } catch (error: any) {
//         throw new Error(error.message);
//     }
// };

